import {
  RETRIEVE_OUTBOUND_CARRIER_FAILURE,
  RETRIEVE_OUTBOUND_CARRIER_REQUEST,
  RETRIEVE_OUTBOUND_CARRIER_SUCCESS,
  CARRIER_CHECKED,
  SELECT_ALL_CARRIERS,
  DESELECT_ALL_CARRIERS,
} from './types/CarrierActionTypes';

export function retrieveOutboundCarriersRequestActionCreator(payload, checkedCarriers) {
  return {
    type: RETRIEVE_OUTBOUND_CARRIER_REQUEST,
    payload,
    checkedCarriers,
  };
}

export function retrieveOutboundCarriersSuccessActionCreator(payload) {
  return {
    type: RETRIEVE_OUTBOUND_CARRIER_SUCCESS,
    payload,
  };
}

export function retrieveOutboundCarriersFailureActionCreator(error) {
  return {
    type: RETRIEVE_OUTBOUND_CARRIER_FAILURE,
    error,
  };
}

export function carrierCheckedActionCreator(checkedCarriers) {
  return {
    type: CARRIER_CHECKED,
    checkedCarriers,
  };
}

export function onSelectAllCarriers(nodes) {
  return {
    type: SELECT_ALL_CARRIERS,
    payload: {
      nodes,
    },
  };
}

export function onDeSelectAllCarriers() {
  return {
    type: DESELECT_ALL_CARRIERS,
  };
}
